import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const MapFailure = () =>{
    const {t} = useTranslation();
    return  <div className='map-failure h-100 container mx-auto '>
                <Row>
                    <Col xs='12' className='px-5 text-center'>
                        <h2>{t('TMP.error.map_failure')}</h2>
                    </Col>
                </Row>
            </div>
}

export default MapFailure;